import React, { useEffect } from 'react';
import { AccountApi } from '@Apis';
import { useNavigate } from 'react-router-dom';
import Loading from '@Components/Common/Loading';

export const SsoLogin = () => {
  const navigate = useNavigate();
  useEffect(() => {
    AccountApi.localAutoLogin()
      .then((res) => {
        if (res.data && res.data.redirectUrl) {
          window.location.href = res.data.redirectUrl;
        } else {
          navigate('/');
        }
      })
      .catch((err) => {
        console.log(err);
        navigate('/login');
      });
  }, [navigate]);
  return <Loading />;
};
